import {
  FOOTER_NEWS_PUBLICATIONS,
  FOOTER_NEWS_PUBLICATIONS_PARAMS,
} from "@config/constants";
import { Link } from "react-router";

const FooterNewsPublications = (): React.ReactElement => {
  const newsPublications = FOOTER_NEWS_PUBLICATIONS.map((item) => ({
    ...item,
    to: `${item.url}?${FOOTER_NEWS_PUBLICATIONS_PARAMS.toString()}`,
  }));

  return (
    <div
      className="flex flex-col gap-y-4 text-xs font-regular"
      data-testid="footer-newsPublications"
    >
      <p className="font-bold my-0">Judul berita terbitan SPH Media</p>
      <div className="flex flex-col">
        {newsPublications.map(({ title, target, to }) => (
          <Link
            key={title}
            to={to}
            target={target}
            rel="noopener noreferrer"
            className="hover:underline"
          >
            {title}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default FooterNewsPublications;
